// extracted by mini-css-extract-plugin
export default {"root":"FieldTermsAcceptance_root__7ZTmQ","link":"FieldTermsAcceptance_link__xV7+6","privacyNotice":"FieldTermsAcceptance_privacyNotice__wG2at textBodyXs"};